import { Button, styled } from '@mui/material';

export const submitBtnSx = { marginLeft: 'auto' };
export const hintsSx = {
  '@media (max-width: 1023px)': {
    left: 'unset',
  },
};

export const CreatePasswordButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;
